export type ProductVideoEntry = {
  title: string;
  caption: string;
  src: string;
  poster: string;
  whatsapp: string;
};

const wa = (message: string) =>
  `https://wa.me/18764482032?text=${encodeURIComponent(message)}`;

const kiosk: ProductVideoEntry = {
  title: "See the Cash Redemption Kiosk at work",
  caption: "Players tap, scan their ticket and collect their cash, so your staff don’t pay out at the counter.",
  src: "/videos/kiosk-cash-redemption.mp4",
  poster: "/videos/kiosk-cash-redemption.jpg",
  whatsapp: wa("Hi Technogenious, I watched the Cash Redemption Kiosk video on your website. I'd like a quote for my venue. (ref: KIOSK-WEB)"),
};

const platinum: ProductVideoEntry = {
  title: "Platinum Bill Acceptor in 20 seconds",
  caption: "UV validation, anti-stringing protection, self-calibration and USB updates.",
  src: "/videos/platinum-bill-acceptor.mp4",
  poster: "/videos/platinum-bill-acceptor.jpg",
  whatsapp: wa("Hi Technogenious, I watched the Platinum Bill Acceptor video on your website. Is it right for my machines? (ref: PLATINUM-WEB)"),
};

const pearlMaster: ProductVideoEntry = {
  title: "Pearl of the Caribbean, installed island wide",
  caption: "Choose the bill acceptor, printer, cabinet and monitor. Buy or lease, with installation.",
  src: "/videos/pearl-caribbean-v2.mp4",
  poster: "/videos/pearl-caribbean-v2.jpg",
  whatsapp: wa("Hi Technogenious, I watched the Pearl of the Caribbean video on your website. I'd like a quote. (ref: PEARL-WEB)"),
};

const partyLink: ProductVideoEntry = {
  title: "How the Scratcher Party link works",
  caption: "Caribbean Roulette and scratch-off games on one shared credit balance.",
  src: "/videos/roulette-scratcher-party-link-v2.mp4",
  poster: "/videos/roulette-scratcher-party-link-v2.jpg",
  whatsapp: wa("Hi Technogenious, I watched the Roulette Scratcher Party Linking System video on your website. I'd like more information. (ref: PARTYLINK-WEB)"),
};

const slimCabinet: ProductVideoEntry = {
  title: "The slim cabinet, lit up",
  caption: "Colour-changing LED lighting around the cabinet and monitor. Choose your bill acceptor, printer and extras in Build Your Machine.",
  src: "/builder/slim-cabinet.mp4",
  poster: "/builder/slim-cabinet-poster.jpg",
  whatsapp: wa("Hi Technogenious, I watched the slim cabinet video on your website. I'd like a quote. (ref: SLIM-WEB)"),
};

// Product page ids (/product/:productId)
export const PRODUCT_VIDEOS: Record<string, ProductVideoEntry> = {
  "6abd00000000000000000001": kiosk,
  "6abc8ea835978d0228ff0c71": platinum,
  "6abff20a6df5c229bb8c36df": partyLink,
  "674df3c143694757801c54af": pearlMaster, // American Style Roulette – Pearl of the Caribbean
};

// Gaming machine ids: shown in the builder (/build-your-machine?machine=:id)
// and on the machine page (/game-product-detail/:id)
export const MACHINE_VIDEOS: Record<string, ProductVideoEntry> = {
  "6738bbcb5cafc60b4ed27920": pearlMaster, // Pearl of the Caribbean Master
  "6ae6b38558044ad0e6e5f08e": slimCabinet, // Pearl of the Caribbean Master in Slim Cabinet
  "6ae6b4e558044ad0e6e5f109": slimCabinet, // Pearl of the Caribbean Slave in Slim Cabinet
};

// Search/ad landing pages (landingPages.ts paths)
export const LANDING_VIDEOS: Record<string, ProductVideoEntry> = {
  "/gaming-machines-for-sale-jamaica": pearlMaster,
  "/gaming-machine-parts-jamaica": platinum,
};

export type ShowcaseEntry = ProductVideoEntry & { id: string; name: string; summary: string; to: string };

// Homepage "Watch it in action" strip, in display order
export const SHOWCASE: ShowcaseEntry[] = [
  { ...kiosk, id: "kiosk", name: "Cash Redemption Kiosk", summary: "Self-service ticket payouts for your venue.", to: "/product/6abd00000000000000000001" },
  { ...pearlMaster, id: "pearl", name: "Pearl of the Caribbean", summary: "Linked roulette, built your way. Buy or lease.", to: "/build-your-machine?machine=6738bbcb5cafc60b4ed27920" },
  { ...partyLink, id: "partylink", name: "Roulette Scratcher Party Link", summary: "Roulette and scratch-off with shared credits.", to: "/product/6abff20a6df5c229bb8c36df" },
  { ...platinum, id: "platinum", name: "Platinum Bill Acceptor", summary: "UV validation and anti-stringing protection.", to: "/product/6abc8ea835978d0228ff0c71" },
];
